/* eslint-disable no-constant-condition */
import React, { useEffect } from "react";

import Body from "Components/Shared/Body";
import AppAdminLayout from "Components/Admin/AdminLayout/AppLayout";
import AppUserLayout from "Components/PucForm/UserLayout/AppLayout";
import { useUserContext } from "Hooks/UserContext";
import { ASSOCIATE_BUYER_SLUG, SUPER_ADMIN } from "Static/utils/commonUtils";

const AppLayout = () => {
  const { loggedIn, setLoggedIn, userDetails, setRole } = useUserContext();

  const CurrentUserRole = userDetails
    ? userDetails.role_slug === SUPER_ADMIN
      ? userDetails.role_slug
      : userDetails.role_slug === ASSOCIATE_BUYER_SLUG
        ? userDetails.role_slug
        : "User"
    : "";

  useEffect(() => {
    if (localStorage.getItem("role") != undefined) {
      setRole(localStorage.getItem("role"));
    }
    if (localStorage.getItem("LoggedIn") === "true") {
      setLoggedIn(true);
    }
  }, []);

  return (
    <>
      {loggedIn && CurrentUserRole === SUPER_ADMIN ? (
        <AppAdminLayout />
      ) : loggedIn && CurrentUserRole === ASSOCIATE_BUYER_SLUG ? (
        <AppUserLayout />
      ) : loggedIn && CurrentUserRole === "User" ? (
        <AppAdminLayout />
      ) : (
        <Body />
      )}
    </>
  );
};
export default React.memo(AppLayout);
